import App from '../index.js';

App.OrganizationsEdit = (function () {
    const emailTpl = $('#email-tpl').html(),
        subsiteTpl = $('#subsite-tpl').html(),
        topicTpl = $('#topic-tpl').html(),
        OVERRIDE_SITE_DISPLAY_TYPE_SUBSITES = 'show_on_subsites',
        OVERRIDE_SITE_DISPLAY_TYPE_MAIN_SITE = 'show_on_main_site';

    function addTopic () {
        const elTopicsList = $(this).closest('.topics-wrapper'),
            clonedTopicTpl = $('<div/>').html(topicTpl).clone(),
            lastTopicItem = elTopicsList.find('.topic-item:last'),
            incrementedIndex = lastTopicItem[0] ? parseInt(lastTopicItem.data('index')) + 1 : 0;

        clonedTopicTpl.find('.topic-item').data('index', incrementedIndex).attr('data-index', incrementedIndex);

        clonedTopicTpl.find('.override-site-display-check-group .form-check-input')
            .attr('id', 'override_site_display_' + incrementedIndex);
        clonedTopicTpl.find('.override-site-display-check-group .form-check-label')
            .attr('for', 'override_site_display_' + incrementedIndex);

        clonedTopicTpl.find('.override-site-display-radio-group .form-check').each(function (index, item) {
            const val = $(this).find('.form-check-input').val();
            $(this).find('.form-check-input')
                .attr('name', 'contact_us_form_topics[' + incrementedIndex + '][override_site_display]')
                .attr('id', val + '_' + incrementedIndex);
            $(this).find('.form-check-label').attr('for',  val + '_' + incrementedIndex);
        });

        elTopicsList.find('.topic-list').append(clonedTopicTpl.html());

        validateButton(elTopicsList.find('.remove-topic'), false);
    }

    function addEmail () {
        const elGroupList = $(this).closest('.emails-group');
        elGroupList.find('.email-list').append(emailTpl);

        validateButton(elGroupList.find('.remove-email'), false);
    }

    function addSubsite () {
        const elGroupList = $(this).closest('.subsites-group');
        elGroupList.find('.subsites-list').append(subsiteTpl);

        validateButton(elGroupList.find('.remove-subsite'), false);
    }

    function removeTopic () {
        const elList = $(this).closest('.topics-wrapper');
        if (elList.find('.topic-list .topic-item').length > 1) {
            $(this).closest('.topic-item').remove();
        }

        validateButton(elList.find('.remove-topic'), elList.find('.topic-list .topic-item').length < 2);
    }

    function removeEmail () {
        const elList = $(this).closest('.emails-group');
        if (elList.find('.email-item').length > 1) {
            $(this).closest('.email-item').remove();
        }

        validateButton(elList.find('.remove-email'), elList.find('.email-item').length < 2);
    }

    function removeSubsite () {
        const elList = $(this).closest('.subsites-group');
        if (elList.find('.subsites-item').length > 1) {
            $(this).closest('.subsites-item').remove();
        }

        validateButton(elList.find('.remove-subsite'), elList.find('.subsites-item').length < 2);
    }

    function validateButton ( el, disable ) {
        if (disable)
            el.attr('disabled', 'disabled');
        else
            el.removeAttr('disabled');
    }

    function submitForm ( e ) {
        e.preventDefault();

        const elForm = $(this);

        elForm.find('.topic-list .topic-item').each(function (index, item) {
            $(this).find('.topic-field').attr('name', 'contact_us_form_topics[' + index + '][name]')

            $(this).find('.override-site-display-checkbox-field').attr('name', 'contact_us_form_topics[' + index + '][enable_override_site_display]');

            if(!$(this).find('.override-site-display-checkbox-field').is(':checked')) {
                $(this).find('.subsites-item').remove();
            }

            $(this).find('.subsites-item').each(function (subsiteIndex) {
                $(this).find('.subsite-field').attr('name', 'contact_us_form_topics[' + index + '][subsites][' + subsiteIndex + ']')
                if ($(this).find('.subsite-field').val() === '') {
                    $(this).remove();
                }
            });

            $(this).find('.email-item').each(function (emailIndex) {
                $(this).find('.email-field').attr('name', 'contact_us_form_topics[' + index + '][emails][' + emailIndex + ']')
                if ($(this).find('.email-field').val() === '') {
                    $(this).remove();
                }
            });
        })

        elForm[0].submit();
    }

    function updateCategoryContactSettingsVisibility() {
        const enabled = $('#enable_contact_button_in_category_no:checked,#enable_contact_button_in_category_yes:checked').val() === '1';
        $('#category_contact_us_settings').toggle(enabled)
    }

    function toggleFollowUp () {
            $('.toggle-follow-up .toggle-follow-up-content').toggleClass('d-none', !$(this).val() === '1');
    }

    function toggleOverrideSiteDisplay() {
        const elTopicItem = $(this).closest('.topic-item'),
            isChecked = $(this).is(':checked');

        elTopicItem.find('.override-site-display-group').toggleClass('d-none', !isChecked);
    }

    return {
        init: function () {
            App.wysiwygEditor('#contact_us_form_instructions', 400, null, null, 'numlist bullist');
            $('#enable_contact_us_form').on('change', function () {
                if (!$(this).is(':checked')) {
                    $('.toggle-contact-us').addClass('d-none');
                    $('.topic-list .email-field, .topic-list .topic-field').removeAttr('required');
                } else {
                    $('.toggle-contact-us').removeClass('d-none');
                    $('.topic-list .email-field, .topic-list .topic-field').attr('required', 'required');
                }
            });

            $('#enable_contact_button_in_category_no,#enable_contact_button_in_category_yes').on('change', updateCategoryContactSettingsVisibility);
            updateCategoryContactSettingsVisibility()

            $('body').on('click', '.add-topic', addTopic)
                .on('click', '.add-email', addEmail)
                .on('click', '.add-subsite', addSubsite)
                .on('click', '.remove-topic:not(:disabled)', removeTopic)
                .on('click', '.remove-email:not(:disabled)', removeEmail)
                .on('click', '.remove-subsite:not(:disabled)', removeSubsite)
                .on('submit', '#organization_form', submitForm)
                .on('change', '.toggle-follow-up [name="follow_up_feedback_email"]', toggleFollowUp)
                .on('change', '.override-site-display-checkbox-field', toggleOverrideSiteDisplay);
        }
    };

})();

// Provide the route name
App.registerRoute('organizations.edit', App.OrganizationsEdit.init);
App.registerRoute('organizations.create', App.OrganizationsEdit.init);

export default App.OrganizationsEdit;
